import type { ImportJobStatus } from '../hooks/useCatalogImportJobInbox';

export const CATALOG_INBOX_OWNER = 'catalog';

export function catalogImportAckType(status: ImportJobStatus): string {
  if (status === 'PENDING' || status === 'RUNNING') return 'CATALOG_IMPORT_ACTIVE';
  if (status === 'COMPLETED') return 'CATALOG_IMPORT_COMPLETED';
  if (status === 'FAILED') return 'CATALOG_IMPORT_FAILED';
  if (status === 'CANCELLED') return 'CATALOG_IMPORT_CANCELLED';
  return 'CATALOG_IMPORT_ACTIVE';
}
